import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { createAppThunk, type IRes } from "store/modules/common";
import Http from "commons/Http";
import { API_NOTICE } from "config/api";
import type { AlarmStatus, AlarmTabType, IAlarmVo, IResAlarmList } from "./AlarmVo";
import type { IPageInfo } from "pages/notice/store/NoticeVo";

const name = "alarm";

export interface IAlarm {
  activeTab: AlarmTabType;
  list: { [key: string]: IAlarmVo[] };
  page_info: { [key: string]: IPageInfo };
}
export const apiGalarmList = createAppThunk<IResAlarmList, number>(`${name}/apiGalarmList`, async (page, thunkApi) => {
  const tab = thunkApi.getState().alarm.activeTab;
  const res = await Http.get<IRes<IResAlarmList>>(`event/alarm`, {
    params: {
      page: page !== undefined ? page : 0,
      size: 20,
      status: tab === "new" ? "PROCESS_ALARM_REQ" : "PROCESS_ALARM_END",
    },
  });

  if (res.data.content) {
    page !== undefined && page > 0
      ? thunkApi.dispatch(rdxSetAlarmMoreList(res.data.content.list))
      : thunkApi.dispatch(rdxSetAlarmList(res.data.content.list));

    thunkApi.dispatch(
      rdxSetAlarmPageInfo({
        page: res.data.content.page_info.page,
        size: 20,
        total_elements: res.data.content.page_info.total_elements,
        totalPage: Math.ceil(res.data.content.page_info.total_elements! / 20) - 1,
      }),
    );
  }
  return res.data;
});

export const apiPalarmStatusSave = createAppThunk<undefined, { id: number; status?: AlarmStatus }>(
  `${name}/apiPalarmStatusSave`,
  async (param, thunkApi) => {
    const params = param.status ? { id: param.id, status: param.status } : { id: param.id };

    const res = await Http.post("event/alarm", params);
    return res.data;
  },
);

const alarmSlice = createSlice({
  name,
  initialState: {
    activeTab: "new",
    list: { new: [], done: [] },
    page_info: {
      new: { total_elements: 0, page: 0, size: 20, totalPage: 0 },
      done: { total_elements: 0, page: 0, size: 20, totalPage: 0 },
    },
  } as IAlarm,
  reducers: {
    rdxSetAlarmActiveTab(state: IAlarm, action: PayloadAction<AlarmTabType>) {
      state.activeTab = action.payload;
    },
    rdxSetAlarmList(state: IAlarm, action: PayloadAction<IAlarmVo[]>) {
      state.list[state.activeTab] = action.payload;
    },
    rdxSetAlarmMoreList(state: IAlarm, action: PayloadAction<IAlarmVo[]>) {
      state.list[state.activeTab] = state.list[state.activeTab].concat(action.payload);
    },

    rdxSetAlarmPageInfo(state: IAlarm, action: PayloadAction<IPageInfo>) {
      state.page_info[state.activeTab] = action.payload;
    },

    // 완료 처리 했을 경우
    rdxSetAlarmAfterReadList(state: IAlarm, action: PayloadAction<number>) {
      // const item = state.list["new"].filter(i => i.id === action.payload);
      state.list.new = state.list["new"].filter(i => i.id !== action.payload);
      // state.list.done = item.concat(state.list.done);
    },
    rdxResetAlarm(state: IAlarm) {
      state.list = { new: [], done: [] };
      state.page_info = {
        new: { total_elements: 0, page: 0, size: 20, totalPage: 0 },
        done: { total_elements: 0, page: 0, size: 20, totalPage: 0 },
      };
    },
  },
});

export const {
  rdxSetAlarmActiveTab,
  rdxSetAlarmList,
  rdxSetAlarmMoreList,
  rdxSetAlarmPageInfo,
  rdxResetAlarm,
  rdxSetAlarmAfterReadList,
} = alarmSlice.actions;
// data 를 관리하는 reducer 기본 반환 설정
export default alarmSlice.reducer;
